import { Suspense, lazy } from 'react'
import type { DisconnectWalletButtonProps } from './types'

const DisconnectEvmButton = lazy(() => import('./disconnect-evm-wallet-button'))

export function DisconnectWalletButton(props: DisconnectWalletButtonProps) {
  const { children } = props

  return (
    <Suspense fallback={children}>
      <DisconnectEvmButton {...props} />
    </Suspense>
  )
}
